@if (isLoaded) {
  <div class="modal-body modal-scss">
    <div [formGroup]="form" class="row">
      <div class="col-md-6 mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'description' | translate }} *</span>
          <i-input
            [type]="'text'"
            [iInput]="{ placeholder: 'tagsInfos.tagDescription' | translate }"
            [control]="form.get('description')"
            [showError]="false"
            styleClass="d-block w-100"></i-input>
        </label>
      </div>
      <div class="col-md-6 p-fluid mb-3">
        <label class="w-100" for="p-treeSelect-create-new-tag">
          <span class="super-compos-label-input">{{ 'service' | translate }}</span>
          <p-treeSelect
            id="p-treeSelect-create-new-tag"
            [emptyMessage]="'noResultFound' | translate"
            [options]="serviceParent"
            #treeSelect
            selectionMode="checkbox"
            [placeholder]="'pleaseSelectAService' | translate"
            appendTo="body"
            (onNodeSelect)="select()"
            (onNodeUnselect)="unselect($event)"
            [filter]="true"
            [filterPlaceholder]="'global.filterPlaceholder' | translate"
            [filterBy]="'label'"
            [filterMode]="'strict'"
            [metaKeySelection]="false"></p-treeSelect
        ></label>
      </div>
      <div class="col-md-6 mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'tagsInfos.displayOrder' | translate }}</span>
          <i-input
            [type]="'number'"
            [iInput]="{ placeholder: 'tagsInfos.displayOrder' | translate }"
            [control]="form.get('ordreAffichage')"
            styleClass="d-block w-100">
          </i-input>
        </label>
      </div>
      <div class="col-md-6 mb-3">
        <span class="super-compos-label-input">{{ 'usable' | translate }}</span>
        <label class="ms-2 mb-0" for="notUsed">
          <p-checkbox id="checkNotUsedEtiquette" formControlName="notUsed" name="notUsed" binary="true"></p-checkbox>
          {{ 'usable' | translate }}</label
        >
      </div>
      <div class="col-md-6 mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'color' | translate }}</span>
          <p-colorPicker
            id="colorpickerCouleurEtiquettes"
            styleClass="w-100"
            formControlName="color"
            appendTo="body"
            id="colorPicker"></p-colorPicker>
        </label>
      </div>
      <div class="col-md-6 p-fluid mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'tagsInfos.recipientGroupToAdd' | translate }} </span>
          <p-dropdown
            id="dropdownGroupAddDestinataireEtiquettes"
            styleClass="w-100"
            formControlName="cocherAjouterDroitAccesGroupeID"
            [virtualScroll]="true"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="groups"
            [filter]="true"
            [placeholder]="'tagsInfos.selectAGroup' | translate"
            [showClear]="true">
          </p-dropdown>
        </label>
      </div>
      <div class="col-md-6 p-fluid mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'tagsInfos.groupToAuthorize' | translate }} </span>
          <p-dropdown
            id="dropdownGroupAllowEtiquettes"
            styleClass="w-100"
            formControlName="courrierActionDroitCocherGroupeID"
            [virtualScroll]="true"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="groups"
            [filter]="true"
            [placeholder]="'tagsInfos.selectAGroup' | translate"
            [showClear]="true">
          </p-dropdown>
        </label>
      </div>
      <div class="col-md-6 p-fluid mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'tagsInfos.groupToUncheckUnlink' | translate }}</span>
          <p-dropdown
            id="dropdownGroupUnlinkEtiquettes"
            styleClass="w-100"
            formControlName="courrierActionDroitDecocherGroupeID"
            [virtualScroll]="true"
            virtualScrollItemSize="30"
            appendTo="body"
            [options]="groups"
            [filter]="true"
            [placeholder]="'tagsInfos.selectAGroup' | translate"
            [showClear]="true">
          </p-dropdown>
        </label>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <i-button id="modalButtonCancelEtiquette" styleClass="red me-2" (click)="ref.close()" [text]="'cancel' | translate"></i-button>
        <i-button
          id="modalButtonConfirmEtiquette"
          styleClass="green"
          [disabled]="!form.valid"
          [text]="'confirm' | translate"
          (click)="submit()"></i-button>
      </div>
    </div>
  </div>
}
